import { put } from 'core/middlewares/utilities';
import { QueryOptions } from 'core/domains/catalog';
import { AVAILABLE_OPTION } from 'core/domains/catalog.d';
import { AvailableShowcases } from 'core/services/bff';
import { catalog } from 'core/use-cases';
/**
 * reset products when Shipping Model changes flow
 *
 */
export function* fetchShowcases(availableShowcases: AvailableShowcases[]) {
  const queryOptions = { itemsPerPage: Number(16) } as QueryOptions;

  for (const AvailableShowcase of availableShowcases) {
    yield put(
      catalog.actions.catalogFetch.request({
        ...queryOptions,
        tag: AvailableShowcase.tag,
        availability: AVAILABLE_OPTION.first,
      }),
    );
  }
}
